module.exports = __webpack_public_path__ + "img/screen-manual-14.5a84b223.png";